import React, { useEffect, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import { Link, useNavigate } from 'react-router-dom';
import styles from '../../css/style.module.css'




import { RiDeleteBin6Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import { VscSettings } from "react-icons/vsc";

import { DeleteSuccessfullyModal, SuccessfullyModal } from '../../components/Modals/Modals';
import FilterModal from '../../components/Modals/FilterModal';
import endPoints from '../../Repository/apiConfig';
import { deleteApi, getApi } from '../../Repository/Api';

import img2 from '../../assest/loading1.gif'
import { formatDateTime } from '../../utils/utils'


const columns = [
  'S.no',
  'Banner Name',
  'Banner Image',
  'Start Date',
  'End Date',
  'Total Clicks',
  'Target Link',
  'Creation Date',
  'Status',
  'Action'
];





const BannerManagement = () => {
  const navigate = useNavigate()
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [bannerdata, setBannerData] = useState([])
  const [loading, setLoading] = useState(false);
  const [selecteddata, setSelectedData] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("");

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };


  const fetchData = async () => {
    await getApi(endPoints.getallbanner(selectedFilter), {
      setResponse: setBannerData,
      setLoading,
      errorMsg: 'Failed to fetch banner!'
    });
  };


  useEffect(() => {
    fetchData();
  }, [selectedFilter]);

  const handleDelete = async () => {
    if (!selecteddata) return;

    await deleteApi(endPoints.deletebanner(selecteddata), {
      setLoading,
      // successMsg: 'Category deleted successfully!',
      errorMsg: 'Failed to delete banner!'
    });

    fetchData();
    setShowDeleteModal(false);
    setShowSuccessModal(true);
    setTimeout(() => setShowSuccessModal(false), 2000);
  };
  const openDeleteModal = (categoryId) => {
    setSelectedData(categoryId);
    setShowDeleteModal(true); // Open confirm delete modal
  };

  const filterOptions = [
    { label: "Active", value: "active" },
    { label: "Expired", value: "inactive" },
  ];

  const handleApply = (appliedFilter) => {
    setSelectedFilter(appliedFilter);
    setShowDropdown(false);
  };


  return (
    <>
      <DeleteSuccessfullyModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleConfirm={handleDelete}
        text="delete Banner"
      />
      <SuccessfullyModal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        text="Successfully Deleted"
      />
      <div className={styles.jobmanagementCotainer}>
        <div className={styles.jobtoppart}>
          <div className={styles.pagetitle}>
            <h6>Banner Management</h6>
          </div>
          <div className={styles.rightbuttons}>
            {showDropdown && (
              <FilterModal
                handleApply={handleApply}
                filterOptions={filterOptions}
                selectedFilter={selectedFilter}
              />
            )}
            <div className={styles.rightbuttons2} onClick={() => navigate('/banner-Management/add')}>
              <FaPlus color='#FFFFFF' />
              <p>Create  New Banner</p>
            </div>
            <div className={styles.filterbutton} onClick={toggleDropdown}>
              <VscSettings color='#737373' size={20} />
              <p>Filters</p>
            </div>
          </div>
        </div>
        <div className={styles.jobchildcontainer}>
          <div className={styles.tablecontainer}>
            <table className={styles.table1}>
              <thead>
                <tr>
                  {columns.map((label, index) => (
                    <th key={index} className={styles.tableHeader}>{label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ?
                  <tr>
                    <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                      <img src={img2} alt="" width={100} height={100} />
                    </td>
                  </tr>
                  :
                  bannerdata?.data?.length === 0 ?
                    <tr>
                      <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                        No data available.
                      </td>
                    </tr>
                    :
                    bannerdata?.data?.map((item, rowIndex) => (
                      <tr key={rowIndex} className={styles.tableRow}>
                        <td className={styles.tableCell}>{rowIndex + 1}</td>
                        <td className={styles.tableCell}>
                          {item.bannerTitle}
                        </td>
                        <td className={styles.tableCell}>
                          <div className={styles.tabledocument}>
                            <img src={item.bannerImage} alt="" />
                          </div>
                        </td>
                        <td className={styles.tableCell}>
                          {formatDateTime(item.activationDate)}
                        </td>
                        <td className={styles.tableCell}>
                          {formatDateTime(item.expirationDate)}
                        </td>
                        <td className={styles.tableCell}>
                          {item.totalClicks}
                        </td>
                        <td className={styles.tableCell}>
                          <div clasName={styles.tablelink}>
                            <p>{item.bannerLink}</p>
                          </div>
                        </td>
                        <td className={styles.tableCell}>
                          {formatDateTime(item.createdAt)}
                        </td>
                        <td className={styles.tableCell}
                          style={{
                            color:
                              item?.status === 'active' ? '#00AD1D' :
                                '#FF0E0E',
                            fontWeight: '600'
                          }}
                        >
                          {item.status}
                        </td>
                        <td>
                          <div className={styles.tableaction}>
                            <Link to={`/banner-Management/edit/${item?._id}`}>
                              <FaRegEdit size={20}   style={{ cursor: "pointer", color: "#e9b44a" }} />
                            </Link>
                            <RiDeleteBin6Line
                              size={20}
                              onClick={() => openDeleteModal(item._id)}
                              style={{ cursor: "pointer", color: "#d9534f" }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>
        </div>

      </div >
    </>
  )
}

export default HOC(BannerManagement)
